import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-langues',
  templateUrl: './langues.component.html',
  styleUrls: ['./langues.component.scss']
})
export class LanguesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
